import { useState } from "react";
import DatePickerInput from "./DatePickerInput";
import { useNavigate } from "react-router-dom";

export default function TicketStepPage() {
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedPackage, setSelectedPackage] = useState("");
  const [quantities, setQuantities] = useState({ Adult: 0, Child: 0 });
  const [activeTab, setActiveTab] = useState("sky");

  const navigate = useNavigate();

  const tabContent = {
    sky: {
      title: (type) => `Sky Terrace (${type})`,
      image: "/1.jpg",
      prices: {
        malaysian: { Adult: 50, Child: 28 },
        international: { Adult: 140, Child: 80 },
      },
    },
    deck: {
      title: (type) => `Observation Deck (${type})`,
      image: "/2.jpg",
      prices: {
        malaysian: { Adult: 60, Child: 35 },
        international: { Adult: 150, Child: 85 },
      },
    },
    combo: {
      title: (type) => `COMBO (${type})`,
      image: "/1.jpg",
      prices: {
        malaysian: { Adult: 90, Child: 50 },
        international: { Adult: 180, Child: 100 },
      },
    },
  };

  const handleSubmit = () => {
    const tickets = ["Adult", "Child"].map((type) => ({
      label: type,
      qty: quantities[type],
      price: tabContent[activeTab].prices[selectedPackage]?.[type] || 0,
    }));

    const total = tickets.reduce((sum, t) => sum + t.qty * t.price, 0);

    const summaryData = {
      date: selectedDate || new Date().toISOString(),
      package:
        selectedPackage === "malaysian"
          ? tabContent[activeTab].title("Malaysian")
          : selectedPackage === "international"
          ? tabContent[activeTab].title("International")
          : "No Package",
      tickets,
      total,
    };

    localStorage.setItem("bookingSummary", JSON.stringify(summaryData));
    navigate("/summary");
  };

  const TicketPackageSection = ({ title, image, quantities, setQuantities }) => {
    const ticketTypes = ["Adult", "Child"];
    const getPrice = (type) =>
      tabContent[activeTab].prices[selectedPackage]?.[type] || 0;

    return (
      <div className="bg-white rounded-xl p-6 shadow-lg">
        <div className="flex items-center gap-4 mb-6">
          <img
            src={image}
            alt="Preview"
            className="  h-32 object-cover   border"
          />
          <div>
            <h2 className="text-xl font-bold text-gray-800">{title}</h2>
            <p className="text-sm text-gray-500">{title}</p>
          </div>
        </div>

        <table className="w-full text-left border">
          <thead className="bg-gray-100">
            <tr>
              <th className="p-3">Ticket Type</th>
              <th className="p-3">Price</th>
              <th className="p-3">Quantity</th>
            </tr>
          </thead>
          <tbody>
            {ticketTypes.map((type) => (
              <tr key={type} className="border-t">
                <td className="p-3">{type}</td>
                <td className="p-3">RM {getPrice(type).toFixed(2)}</td>
                <td className="p-3">
                  <div className="flex items-center gap-2">
                    <button
                      onClick={() =>
                        setQuantities((prev) => ({
                          ...prev,
                          [type]: Math.max((prev[type] || 0) - 1, 0),
                        }))
                      }
                      className="bg-gray-200 px-3 py-1 rounded text-sm"
                    >
                      –
                    </button>
                    <span className="min-w-[20px] text-center">
                      {quantities[type] || 0}
                    </span>
                    <button
                      onClick={() =>
                        setQuantities((prev) => ({
                          ...prev,
                          [type]: (prev[type] || 0) + 1,
                        }))
                      }
                      className="bg-gray-200 px-3 py-1 rounded text-sm"
                    >
                      +
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <div
      className="min-h-screen bg-cover bg-center flex items-center justify-center"
      style={{ backgroundImage: `url('/bg.png')`, backdropFilter: "blur(8px)" }}
    >
      <div className="bg-[#F8F9FA] p-8 md:p-12 rounded-xl max-w-4xl w-full">
        {/* Tabs */}
        <div className="flex flex-wrap justify-center md:justify-center space-x-0 md:space-x-4 gap-2 md:gap-0 mb-8">
          {["sky", "deck", "combo"].map((tab) => (
            <button
              key={tab}
              onClick={() => {
                setActiveTab(tab);
                setSelectedPackage("");
                setQuantities({ Adult: 0, Child: 0 });
              }}
              className={`flex-1 md:flex-none px-4 py-2 rounded-md shadow-md text-xs md:text-base font-semibold ${
                activeTab === tab
                  ? "bg-white text-[#007bff] border border-[#007bff]"
                  : "bg-white text-black"
              }`}
            >
              {tab === "sky"
                ? "Sky Terrace"
                : tab === "deck"
                ? "Observation Deck"
                : "COMBO"}
            </button>
          ))}
          <div className="w-full md:w-auto text-center md:ml-auto font-bold text-white text-sm md:text-lg">
            00:22
          </div>
        </div>

        {/* Steps */}
        <div className="flex flex-wrap justify-center md:justify-between items-center text-gray-500 mb-10 text-xs md:text-base font-semibold space-x-2 md:space-x-0">
          <div className="text-blue-500 border-b-2 border-blue-500 pb-1">1. Ticket</div>
          <div>2. Summary</div>
          <div>3. Payment</div>
          <div>4. Done</div>
        </div>

        {/* Date */}
        <div className="grid grid-cols-1 md:grid-cols-[100px_1fr] gap-y-4 md:gap-y-6 gap-x-0 md:gap-x-4 mb-6 items-center">
          <label className="font-bold md:text-right">Date:</label>
          <DatePickerInput selectedDate={selectedDate} setSelectedDate={setSelectedDate} />
        </div>

        {/* Package */}
        <div className="grid grid-cols-1 md:grid-cols-[100px_1fr] gap-y-4 md:gap-y-6 gap-x-0 md:gap-x-4 mb-6 items-center">
          <label className="font-bold md:text-right">Package:</label>
          <select
            className="w-full text-neutral-400 border border-black p-3 rounded text-sm"
            value={selectedPackage}
            onChange={(e) => setSelectedPackage(e.target.value)}
          >
            <option value="">Please select package</option>
            <option value="malaysian">
              {activeTab === "sky"
                ? "Sky Terrace (Malaysian)"
                : activeTab === "deck"
                ? "Observation Deck (Malaysian)"
                : "COMBO (Malaysian)"}
            </option>
            <option value="international">
              {activeTab === "sky"
                ? "Sky Terrace (International)"
                : activeTab === "deck"
                ? "Observation Deck (International)"
                : "COMBO (International)"}
            </option>
          </select>
        </div>

        {/* Ticket Section */}
        {selectedPackage && (
          <TicketPackageSection
            title={tabContent[activeTab].title(
              selectedPackage === "malaysian" ? "Malaysian" : "International"
            )}
            image={tabContent[activeTab].image}
            quantities={quantities}
            setQuantities={setQuantities}
          />
        )}

        {/* Buttons */}
        <button
          onClick={handleSubmit}
          className="w-full bg-[#3e3e52] hover:bg-[#0BBAE3] hover:text-black transition-all text-xs text-cyan-400 font-semibold p-3 md:p-4 rounded-md mt-6"
        >
          Add to Cart
        </button>

        <div className="flex flex-col md:flex-row justify-end md:space-x-4 space-y-4 md:space-y-0 mt-16 md:mt-24">
          <button className="bg-[#DC3545] text-white text-xs px-6 md:px-12 py-3 rounded-md font-bold">
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            className="hover:bg-[#0BBAE3] bg-[#3e3e52] hover:text-black transition-all text-cyan-400 text-xs px-6 md:px-12 py-3 rounded-md font-bold"
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
}
